export interface Preset {
  id: 'hverdag' | 'sammensatte' | 'domene' | 'kode';
  label: string;
  no: string;
  en: string;
}

/**
 * Initial preset texts. Numerical claims (Norwegian-premium %, rule-of-thumb
 * chars/token) are verified empirically by Task 20 before launch.
 * If a preset's empirical premium gradient is too flat, refine its text here.
 */
export const presets: readonly [Preset, Preset, Preset, Preset] = [
  {
    id: 'hverdag',
    label: 'hverdag',
    no: 'Vi går på jobb om morgenen og kommer hjem på ettermiddagen. Det blir middag, kaffe og litt avis før kvelden.',
    en: 'We go to work in the morning and come home in the afternoon. There is dinner, coffee and a bit of newspaper before the evening.'
  },
  {
    id: 'sammensatte',
    label: 'sammensatte ord',
    no: 'Arbeidsmiljøutvalget i samfunnsøkonomi anbefaler kompetansehevingstiltak for forskningsadministrasjonen og inntektsfordelingsmodellen.',
    en: 'The working-environment committee in social economics recommends competence-building measures for the research administration and the income-distribution model.'
  },
  {
    id: 'domene',
    label: 'domene',
    no: 'NHH videreutvikler satsningen på digital transformasjon, bærekraftig finans og strategisk ledelse i en stadig mer kompleks næringslivsvirkelighet.',
    en: 'NHH continues to develop its focus on digital transformation, sustainable finance and strategic leadership in an increasingly complex business reality.'
  },
  {
    id: 'kode',
    label: 'tall og kode',
    no: 'function nbr(x) { return x * 1.25; } // 1024 + 2048 = 3072. ID: 5e8a1c, port: 8080.',
    en: 'function nbr(x) { return x * 1.25; } // 1024 + 2048 = 3072. ID: 5e8a1c, port: 8080.'
  }
];
